"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledListboxOptionMeta = void 0;
var _ListboxOptionMeta = require("./ListboxOptionMeta");
// TODO: in v9, move styled() from ListboxOptionMeta.jsx to here
var StyledListboxOptionMeta = _ListboxOptionMeta.ListboxOptionMeta;
exports.StyledListboxOptionMeta = StyledListboxOptionMeta;